import React, { useMemo, useRef, useState, useEffect } from 'react';
import I18n from "../../../localization";
import { makeStyle } from '../style';
import { Button, Card, CardContent, FormControl, MenuItem, Select } from '@material-ui/core';
import { maskedSn } from '../../../utils/utility';
import DropDownArrow from '../../../icons/drowpDownArrow';

export default function LinkingForm({ airDevices = [], hvacs = [], handleUpdatedView , isDarkMode=false }) {
  const classes = makeStyle();
  const [devices, setDevices] = useState(airDevices);

  const initialDevicesRef = useRef(
    airDevices.map(d => ({
      'device-id': d['device-id'],
      'linked-hvac': d['linked-hvac'] ?? null
    }))
  );

  useEffect(() => {
    setDevices(airDevices);
    initialDevicesRef.current = airDevices.map(d => ({
      'device-id': d['device-id'],
      'linked-hvac': d['linked-hvac'] ?? null
    }));
  }, [airDevices]);

  const handleChange = (deviceId, hvacId) => {
    setDevices(prev =>
      prev.map(d =>
        d['device-id'] === deviceId
          ? { ...d, 'linked-hvac': hvacId || null }
          : d
      )
    );
  };

  const hasChanges = useMemo(() => {
    return devices.some(d => {
      const initial = initialDevicesRef.current.find(i => i['device-id'] === d['device-id']);
      return (initial?.['linked-hvac'] ?? null) !== (d['linked-hvac'] ?? null);
    });
  }, [devices]);

  const hasEmptySelection = useMemo(() => devices.some(d => !d['linked-hvac']), [devices]);

  const groupedDevices = useMemo(() => {
    const map = {};
    devices.forEach(d => { if (d.primary) map[d['device-id']] = { primary: d, children: [] }; });
    devices.forEach(d => { if (!d.primary && d['primary-device-id']) map[d['primary-device-id']]?.children.push(d); });
    return Object.values(map);
  }, [devices]);

  return (
    <>
      <div className={`${classes.linkingFormContainer} ${isDarkMode ? 'dark-mode':''}`}>
        {groupedDevices.map(group => (
          <Card key={group.primary['device-id']} className={classes.cardContainer} style={{ marginBottom: 16 }}>
            <CardContent>
              {[group.primary, ...group.children].map(device => (
                <div key={device['device-id']} className={device.primary ? classes.HqSection : classes.HdSection}>
                  
                  <div className="deviceInfo">
                    <span className="device-type">{device.primary ? I18n.t("mobile.AirDeviceProvisioning.iqAirPrimary") : I18n.t("mobile.AirDeviceProvisioning.iqAirSecondary")}</span>
                    <span className="device-details">{device.primary ? device.name : maskedSn(device['serial-number'])}</span>
                  </div>

                  <FormControl className={classes.formControl}>
                    <Select
                      value={device['linked-hvac'] ?? ''}
                      onChange={e => handleChange(device['device-id'], e.target.value)}
                      className={classes.selectDropdown}
                      IconComponent={DropDownArrow}
                      displayEmpty
                    >
                      <MenuItem value="">
                        {I18n.t('mobile.linkHvacToThermostat.selectHVAC')}
                      </MenuItem>

                      {hvacs.map(h => (
                        <MenuItem key={h['device-id']} value={h['device-id']}>
                          {h.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                </div>
              ))}
            </CardContent>
          </Card>
        ))}
      </div>

      <div className={classes.linkButtonContainer}>
        <Button
          className={classes.buttonStyle}
          disabled={!hasChanges || hasEmptySelection}
          onClick={() => handleUpdatedView(devices)}
        >
          {I18n.t('mobile.linkHvacToThermostat.apply')}
        </Button>
      </div>
    </>
  );
}
